import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
    Button,
    Collapse,
    Nav,
    NavItem,
    NavLink,
    Navbar,
    NavbarBrand,
    NavbarToggler,
} from "reactstrap";
import { logout } from "../store/actions/authAction";
import { getPendingRequests } from "../store/actions/MomentosActions";

const MomentosNavabr = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user, uid } = useSelector((state) => state.authUser);
    const { pendingRequests } = useSelector((state) => state.momentos);
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        if (user?.role !== "role") {
            dispatch(getPendingRequests(uid));
        }
    }, []);

    return (
        <>
            <Navbar light expand="lg" className="momentos_navbar p-3">
                <NavbarBrand href="/">Memento</NavbarBrand>
                {location.pathname !== "/auth/login" && (
                    <NavbarToggler onClick={toggle} />
                )}

                <Collapse
                    isOpen={isOpen}
                    navbar
                    className="d-flex justify-content-lg-between align-items-center flex-column flex-lg-row"
                >
                    {location.pathname !== "/auth/login" ? (
                        <>
                            {user?.role == "fan" ? (
                                <Nav className="mx-auto text-center" navbar>
                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push("/main/gallery")
                                            }
                                        >
                                            Gallery
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push(
                                                    "/main/bought-momentos"
                                                )
                                            }
                                        >
                                            Bought Mementos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push(
                                                    "/main/my-requests"
                                                )
                                            }
                                        >
                                            Memento Requests
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push(
                                                    "/main/terms&conditions"
                                                )
                                            }
                                        >
                                            Instructions
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            ) : (
                                <Nav className="mx-auto text-center" navbar>
                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push("/main/mementos")
                                            }
                                        >
                                            Manage Mementos
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push(
                                                    "/main/momentos-requests"
                                                )
                                            }
                                        >
                                            Memento Requests
                                            {pendingRequests !== 0 && (
                                                <sup
                                                    style={{
                                                        verticalAlign: "super",
                                                        color: "white",
                                                        background: "red",
                                                        padding: "2px 4px",
                                                        borderRadius: "50%",
                                                    }}
                                                >
                                                    {pendingRequests}
                                                </sup>
                                            )}
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push("/main/qr-codes")
                                            }
                                        >
                                            QR Codes
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push(
                                                    "/main/terms&conditions"
                                                )
                                            }
                                        >
                                            Instructions
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className="cursor-pointer"
                                            onClick={() =>
                                                history.push(
                                                    "/main/momento_drafts"
                                                )
                                            }
                                        >
                                            Momento Drafts
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            )}
                        </>
                    ) : (
                        <div></div>
                    )}
                    {location.pathname !== "/auth/login" && (
                        <Button
                            className="logout_button"
                            color="primary"
                            onClick={(e) => {
                                e.preventDefault();
                                dispatch(logout());
                            }}
                        >
                            Logout
                        </Button>
                    )}
                </Collapse>
            </Navbar>
        </>
    );
};

export default MomentosNavabr;
